import { CategorySidePanelProps } from '@components/category/CategorySidePanel/CategorySidePanel'
import { FC } from 'react'
import { CategorySidePanel } from '@components/category'
import { CwsModal, CwsModalBody } from '@components/cws'
import { useMediaLess } from '@ui/hooks/useMediaLess'

export const MOBIL_SIZE_FILTER = 1023
export const SidePanelWrapper: FC<CategorySidePanelProps> = ({ ...rest }) => {
  const isMobile = useMediaLess(MOBIL_SIZE_FILTER)

  if (isMobile) {
    return (
      <CwsModal id="side-panel-filter-modal" visible={false}>
        <CwsModalBody>
          <CategorySidePanel {...{ ...rest }} />
        </CwsModalBody>
      </CwsModal>
    )
  }

  return <CategorySidePanel {...{ ...rest }} />
}
